import type { ConnectionPhase } from '@/entities/connection-entity';

export function shouldPollPanelStatus(
	isSenderApp: boolean,
	connectionPhase: ConnectionPhase,
	isDevMode: boolean,
): boolean {
	if (isDevMode) return false;
	if (!isSenderApp && connectionPhase === 'online') return false;
	return true;
}
